// Thin wrapper over the Plausible queue stub in index.html.
//
// Only a handful of events are worth sending. The question this instrumentation
// exists to answer is "which thing we did brought people who actually played",
// so the events are the steps of that funnel and nothing else. Retention, DAU
// and revenue come from Supabase, where the data is ours and more accurate.
//
// Never throw: analytics failing must never break a match. The stub in
// index.html means plausible() exists before the script loads, but an ad
// blocker can remove it entirely, so the optional call is load-bearing.

type Props = Record<string, string | number | boolean>;

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: Props; revenue?: { currency: string; amount: number } }) => void;
  }
}

export function track(event: string, props?: Props) {
  try {
    window.plausible?.(event, props ? { props } : undefined);
  } catch {
    // Analytics is never worth an exception.
  }
}
